import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageStateManagerService {

  constructor() { }
  private pageState: { [route: string]: number } = {};  
  
    setPageState(route: string, page: number): void {
      this.pageState[route] = page;
    }
  
    getPageState(route: string): number  {
      return this.pageState[route] !== undefined ? this.pageState[route] : 1;
    }
  
    clearPageState(route: string): void {
      delete this.pageState[route];
    }
  }